module.exports = __webpack_public_path__ + "images/mercator-86bc5523c7d042b53b8213f479907f32.jpg";